<template>
    <div class="blank-layout">
        <div class="blank-layout__content">
            <slot />
        </div>
        <div class="blank-layout__footer">
            <div class="text-caption text-grey">
                &copy;{{ new Date().getFullYear() }}&nbsp;AV&nbsp;Venture&nbsp;Building |&nbsp;v{{
                    GENERAL_STORE.APP_VERSION
                }}
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { useGeneralStore } from "@/store/general.store";

const GENERAL_STORE = useGeneralStore();
</script>
